<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 购物车->收货地址 -->
    <div class="main" style="padding: 0">
      <div class="df-maina-ddtit" style="margin: 0"><span>提交订单</span></div>
      <div class="df-buybox">
        <div class="df-buyboxa"></div>
        <div class="df-buyboxb">
          <div class="df-buyboxba">
            <span><i>1</i></span
            ><span class="on"><i>2</i></span
            ><span><i>3</i></span>
          </div>
          <div class="df-buyboxbb">
            <span>1.我的购物车</span><span class="on">2.填写核对订单信息</span
            ><span>3.成功提交订单</span>
          </div>
        </div>
      </div>
      <div class="df-buya">
        可批量导入或在线填写收货人信息并生成对应订单,商品为购物车内商品
      </div>
      <div class="df-buyd">
        <div class="df-buyd-inpa">
          批量导入收货地址
          <input
            type="file"
            ref="referenceUpload"
            readonly="readonly"
            class="getInterOrder hands"
            value="导入订单"
            @change="chooseFile"
          />
        </div>

        <el-button class="buybuta" @click="adderssAddbox = true">
          填写收货地址
        </el-button>

        <el-button class="buybuta" @click="getAddressShow">
          选择收货地址
        </el-button>
        <el-button class="buybuta" @click="getBefore"> 地址模板下载 </el-button>
        <el-button class="buybuta buybuta2" @click="goCar"> 返 回 </el-button>
      </div>
      <div v-if="shoppingCar.length > 0" class="df-buyb">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <th>图片</th>
            <th>商品名称</th>
            <th>SKU</th>
            <th>数量</th>
            <th>单价</th>
            <th>总价</th>
          </tr>
          <tr v-for="(item, index) of shoppingCar" :key="index">
            <td>
              <img v-if="item.pcImg" :src="item.pcImg" class="img" />
              <img v-else src="../../../images/image.png" class="img" />
            </td>
            <td>{{ item.goodsName || "商品名称" }}</td>
            <td>{{ item.sku || "--" }}</td>
            <td>{{ item.amount || "0" }}</td>
            <td>{{ to_f(item.shopPrice || "0.00") }}</td>
            <td>{{ to_f(item.shopPrice * item.amount || "0.00") }}</td>
          </tr>
        </table>
      </div>
      <div v-else class="df-buyb">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <th>图片</th>
            <th>商品名称</th>
            <th>SKU</th>
            <th>数量</th>
            <th>单价</th>
            <th>总价</th>
          </tr>
          <tr>
            <td colspan="8" rowspan="8">
              <span class="nobuyData"
                >购物车暂无任何商品，请去<span
                  @click="$router.push('/goodsCenter')"
                  >商品列表</span
                >进行采购</span
              >
            </td>
          </tr>
        </table>
      </div>
      <!-- <div class="df-buyc">
        总计(元):
        <span style="font-size:18px;color:#e7584f;margin-right:10px;">{{
          to_f(totalPrice)
        }}</span>
        <el-button
          size="small"
          style="background:#e5e4e2;border-color:#97c5e9;padding:7px 20px;margin-left:5px;"
          @click="goAddAddress"
        >
          去结算
        </el-button>
      </div> -->

      <el-dialog
        :title="editTitle2"
        :visible.sync="adderssAddbox"
        class="df-buyedialog"
      >
        <div class="df-buye">
          <div class="item">
            <div class="top"><span>★</span>收件人</div>
            <div class="bottom">
              <input
                v-model="consignee"
                type="text"
                placeholder="请输入收件人"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>★</span>收件人电话</div>
            <div class="bottom">
              <input
                v-model="consigneePhone"
                type="text"
                placeholder="请输入收件人电话"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>★</span>收件人地址</div>
            <div class="bottom">
              <input
                v-model="consigneeAddr"
                type="text"
                placeholder="请输入收件人地址"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span></span>备注</div>
            <div class="bottom">
              <textarea
                v-model="remark"
                name=""
                id=""
                cols="30"
                rows="3"
                class="img"
              ></textarea>
            </div>
          </div>
          <div class="buttons">
            <span @click="addAddressBefore">确 认</span>
          </div>
        </div>
      </el-dialog>

      <div class="main borderShadow">
        <div class="order">
          <el-table
            :data="orderInfo"
            style="width: 100%"
            :cell-style="{
              'text-align': 'center',
              'border-color': '#dbdbdb',
              position: 'relative',
              'background-color': '#f7f5f6',
              'border-right': '1px solid #e7e6e4',
            }"
            :header-cell-style="{
              'background-color': '#b6b6b6',
              color: '#000',
              fontSize: '14px',
              fontWeight: '300',
              'text-align': 'center',
            }"
          >
            <el-table-column prop="num" align="center" label="序号" width="65">
              <template slot-scope="scope">
                {{ (pageNum - 1) * 10 + (scope.$index + 1) }}
              </template>
            </el-table-column>

            <el-table-column prop="goodsName" label="商品名称" width="210">
              <template slot-scope="scope">
                {{ scope.row.goodsName }}
              </template>
            </el-table-column>
            <el-table-column prop="goodsSku" label="商品SKU" width="210">
              <template slot-scope="scope">
                {{ scope.row.goodsSku }}
              </template>
            </el-table-column>
            <el-table-column prop="consignee" label="联系人" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.consignee">{{
                  scope.row.consignee
                }}</span>
                <span class="error" v-else>错误联系人姓名</span>
              </template>
            </el-table-column>

            <el-table-column prop="consigneePhone" label="电话" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.consigneePhone">{{
                  scope.row.consigneePhone
                }}</span>
                <span class="error" v-else>错误联系人电话</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="isStock"
              prop="goodsStock"
              label="库存"
              min-width="70"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.goodsStock">{{
                  getShowStock(scope.row.goodsStock)
                }}</span>
                <span class="error" v-else>库存不足</span>
              </template>
            </el-table-column>

            <el-table-column prop="consigneeAddr" label="收货地址">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.province &&
                    scope.row.city &&
                    scope.row.area &&
                    scope.row.consigneeAddr
                  "
                  >{{
                    scope.row.province +
                    scope.row.city +
                    scope.row.area +
                    scope.row.consigneeAddr
                  }}</span
                >
                <span class="error" v-else
                  ><el-link
                    type="primary"
                    @click="editAddress(scope.$index, scope.row)"
                    >错误收货地址</el-link
                  ></span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="deliveryName"
              label="快递名称"
              min-width="85"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.isDelivery == 0">
                  <el-link @click="editDelivery(scope.$index, scope.row)">{{
                    scope.row.deliveryName
                  }}</el-link>
                </div>
                <div class="error" v-else>
                  <el-link
                    type="primary"
                    @click="editDelivery(scope.$index, scope.row)"
                    >错误快递</el-link
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="stockId" label="发货仓库" min-width="85">
              <template slot-scope="scope">
                <el-link @click="editStock(scope.$index, scope.row)">{{
                  scope.row.stockName
                }}</el-link>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" width="120" />
          </el-table>
          <div class="none" v-if="shoppingCar.length <= 0">
            暂无收货地址，未能生成订单
          </div>
        </div>
        <div class="buttons flexStyle1" v-if="orderInfo.length > 0">
          <div
            class="hands item"
            @click="submitBefore"
            style="background: #4ea5db"
          >
            确认生成订单
          </div>
        </div>
      </div>
    </div>
    <!-- 购物车->收货地址 -->

    <el-dialog
      title="快递修改"
      top="28vh"
      width="400px"
      :visible.sync="deliveryShow"
    >
      <el-form :model="kdForm">
        <el-form-item label="快递名称" :label-width="formLabelWidth">
          <el-select
            v-model="kdForm.deliveryId"
            size="small"
            placeholder="请选择快递名称"
          >
            <el-option
              v-for="(item2, index2) in kdList2"
              :key="index2"
              :label="item2.deliveryName"
              :value="item2.deliveryId"
              :disabled="item2.isWeb == '0' && item2.status == '1'"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDelivery">确 定</el-button>
        <el-button @click="closeDelivery">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="地址修改" :visible.sync="editShow">
      <el-form :model="dialogForm">
        <el-form-item label="选择地区：" :label-width="formLabelWidth">
          <el-col :span="6">
            <el-form-item prop="selectProv">
              <el-select
                size="small"
                style="width: 95%"
                v-model="dialogForm.province"
                v-on:change="getProv($event)"
                filterable
                placeholder="请选择省份"
              >
                <el-option
                  :value="n.name"
                  :key="index"
                  :label="n.name"
                  v-for="(n, index) in dataProv"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="selectCity">
              <el-select
                size="small"
                style="width: 95%"
                v-model="dialogForm.city"
                v-on:change="getCity($event)"
                filterable
                placeholder="请选择城市"
              >
                <el-option
                  :value="n.name"
                  :key="index"
                  :label="n.name"
                  v-for="(n, index) in dataCity"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="selectCountry">
              <el-select
                size="small"
                style="width: 95%"
                v-model="dialogForm.area"
                v-on:change="getArea($event)"
                filterable
                placeholder="请选择区/县"
              >
                <el-option
                  :value="n"
                  :key="index"
                  :label="n"
                  v-for="(n, index) in dataArea"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input
            v-model="dialogForm.consigneeAddr"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddress">确 定</el-button>
        <el-button @click="closeAddressShow">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="editTitle" :visible.sync="adderssSelect">
      <el-table
        :data="addressList"
        style="width: 100%"
        :header-cell-style="{
          'background-color': '#f5f5f5',
          color: 'rgb(0, 0, 0)',
          'border-bottom': '1px #d0d0d0 solid',
        }"
      >
        <el-table-column prop="linkMan" label="收货人" width="130">
          <template slot-scope="scope">
            {{ scope.row.linkMan }}
          </template>
        </el-table-column>
        <el-table-column prop="cellPhone" label="手机号码" width="120" />

        <el-table-column prop="linkAddress" label="地址">
          <template slot-scope="scope">
            <div v-html="getAddress(scope.row)"></div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="scope">
            <div>
              <el-button
                size="mini"
                @click="handleSelect(scope.$index, scope.row)"
                >选择</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <br />

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="发货仓库"
      top="28vh"
      width="400px"
      :visible.sync="stockShow"
    >
      <el-form :model="ckForm">
        <el-form-item label="发货仓库" :label-width="formLabelWidth">
          <el-select
            v-model="ckForm.stockId"
            size="small"
            placeholder="请选择仓库名称"
          >
            <el-option
              v-for="(item2, index2) in ckList"
              :key="index2"
              :label="item2.stockName"
              :value="item2.stockId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveStock">确 定</el-button>
        <el-button @click="closeStock">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  getUrl,
  addressCutRequest,
  shoppingCarSubmitMakeOrderRequest,
  exportReequest,
  shoppingCarIntoMuchAddressRequest,
  orderInsertsRequest,
  getAddresslListRequest,
  kdListRequest,
  cityRequest,
  ckListRequest,
  getGoodStockRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      isStock: true,
      consignee: "", // 1.1.收货人
      consigneePhone: "", // 1.2.收货电话
      consigneeAddr: "", // 1.3.收货地址
      freight: "10.00", // 1.4.运费
      remark: "", // 1.5.备注
      submitSwitch: true, // 1.6.请求开关
      token: "", // 1.7.token
      adderssSwitch: false, // 1.8.填写收货地址开关
      adderssSelect: false, // 1.8.填写收货地址开关
      orderInfo: [], // 1.9.订单信息
      fileTypes: {
        // 1.10.可上传文件类型
        accept:
          "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      skus: "", // 1.11.skus
      editTitle: "选择收货地址",
      editTitle2: "填写收货地址",
      adderssAddbox: false,
      addressList: [],
      totalPages: 1, // 1.1.总页码,
      pageNum: 1, // 1.2.当前页码
      total: 1, // 1.3.总条数
      pageSize: 10, // 1.4.每页条数
      deliveryShow: false,
      deliveryId: null,
      kdList: [],
      kdList2: [],
      kdForm: {
        deliveryId: null,
        deliveryName: null,
      },
      editShow: false,
      dataProv: [],
      dataCity: [],
      dataArea: [],
      dialogForm: {
        province: "",
        city: "",
        area: "",
        consigneeAddr: "",
      },
      formLabelWidth: "120",
      stockShow: false,
      ckList: [],
      ckForm: {
        stockId: null,
        stockName: null,
      },
    };
  },

  components: {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },
    getList() {
      // 3.4.获取套餐列表信息
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };

      getAddresslListRequest(data).then((res) => {
        this.addressList = res.data.map((item) => {
          item.amount = 1;
          return item;
        });

        this.total = res.totals || 1;
        this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
      });
    },
    getAddress(row) {
      return (
        (row["province"] || "") +
        "" +
        (row["city"] || "") +
        "" +
        (row["counties"] || "") +
        "" +
        row["linkAddress"]
      );
    },
    handleSelect(index, row) {
      this.openLoading();

      let data = {
        consignee: row.linkMan,
        consigneePhone: row.cellPhone,
        consigneeAddr: this.getAddress(row),
        goodsSku: this.skus,
        remark: row.remark,
        index: index,
      };
      this.adderssSelect = false;
      //this.parseSkus();

      addressCutRequest(data).then((res) => {
        this.closeLoading();
        if (Array.isArray(res.data)) {
          this.ownParseOrderInfo(res.data);
        } else {
          this.ownParseOrderInfo(res.data);
        }
      });
    },
    // 3.methods
    submitBefore() {
      // 3.1.确认之前
      if (this.orderInfo.length <= 0) {
        this.$notify({
          title: "提示",
          message: "请填写或导入地址信息",
        });
        return;
      }

      let newlist = this.orderInfo.map((item) => {
        let newObj = {
          consignee: item.consignee,
          consigneeAddr: item.consigneeAddr,
          consigneePhone: item.consigneePhone,
          goodsName: item.goodsName,
          goodsSku: item.goodsSku,
          area: item.area || "",
          city: item.city || "",
          province: item.province || "",
          isDelivery: item.isDelivery,
        };
        return newObj;
      });

      let msg = "";
      let jj = 0;
      let result = newlist.some((item) => {
        jj++;
        let res = Object.keys(item).some((key) => {
          if (
            key == "area" ||
            key == "remark" ||
            key == "errCode" ||
            key == "deliveryId" ||
            key == "kdAry"
          ) {
            return false;
          }
          if (key == "goodsSku") {
            if (item[key].indexOf("无效SKU") != -1) {
              msg = "第" + jj + "行，商品错误";
              return true;
            }
          }
          if (key == "province") {
            if (item[key] == "") {
              msg = "第" + jj + "行，地址省份不能为空！";
              return true;
            } else {
              return false;
            }
          }

          if (key == "city") {
            if (item[key] == "") {
              msg = "第" + jj + "行，地址城市不能为空！";
              return true;
            } else {
              return false;
            }
          }

          if (key == "consigneeAddr") {
            if (item[key] == "") {
              msg = "第" + jj + "行，详细地址不能为空！";
              return true;
            } else {
              return false;
            }
          }

          if (key == "isDelivery") {
            if (item[key] == 1) {
              msg = "第" + jj + "行，快递错误！";
              return true;
            } else {
              return false;
            }
          }
          if (!item[key]) {
            msg = "第" + jj + "行，数据有误";
            return true;
          }
        });
        return res;
      });

      if (!result) {
        this.submitInter();
        return;
      }

      this.$message.error(
        msg == ""
          ? "当前导入订单中存在错误信息，请按照标准核实后重新导入或者填写信息"
          : msg
      );
    },

    verifacation() {
      // 3.2.校验表单方法
      let result = false;

      if (!this.consignee.trim()) {
        // 校验收货人
        this.$notify({
          title: "提示",
          message: "请输入收货人",
        });
      } else {
        if (this.consigneePhone.trim().length != 11) {
          // 校验收货电话
          if (this.consigneePhone.trim().indexOf("-") == -1) {
            this.$notify({
              title: "提示",
              message: "请输入11位正确电话号码",
            });
          } else {
            if (!this.consigneeAddr.trim()) {
              // 校验收货地址
              this.$notify({
                title: "提示",
                message: "请输入收货地址",
              });
            } else {
              if (!this.freight.trim()) {
                // 校验运费
                this.$notify({
                  title: "提示",
                  message: "请输入运费",
                });
              } else {
                result = true;
              }
            }
          }
        } else {
          if (!this.consigneeAddr.trim()) {
            // 校验收货地址
            this.$notify({
              title: "提示",
              message: "请输入收货地址",
            });
          } else {
            if (!this.freight.trim()) {
              // 校验运费
              this.$notify({
                title: "提示",
                message: "请输入运费",
              });
            } else {
              result = true;
            }
          }
        }
      }

      return result;
    },

    submit() {
      // 3.3.确认订单
      let webCartList = this.shoppingCar.map((item) => {
        let newObj = {};
        newObj.amount = item.amount;
        newObj.goodsId = item.goodsId;
        newObj.goodsName = item.goodsName;
        return newObj;
      });

      let data = {
        webCartList,
        consignee: this.consignee,
        consigneePhone: this.consigneePhone,
        consigneeAddr: this.consigneeAddr,
        freight: this.freight,
        remark: this.remark,
      };

      shoppingCarSubmitMakeOrderRequest(data).then((res) => {
        if (res.code != 500) {
          this.$message({
            type: "success",
            message: res.msg,
          });

          setTimeout(() => {
            this.$router.push("/goodsCenter");
          }, 500);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },

    goCar() {
      // 3.4.回到商品购物车列表页面
      this.$emit("changeStep");
    },
    getAddressShow() {
      this.adderssSelect = true;
    },
    getBefore() {
      // 3.5.下载购物车导入模版之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认下载?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.get();
          }
        },
      });
    },

    get() {
      // 3.6.下载购物车导入模版
      exportReequest("api/download/cart/template").then((res) => {
        var aLink = document.createElement("a");
        aLink.href = getUrl(res.url);
        aLink.download = "购物车导入模版.xls";
        aLink.style.display = "none";
        aLink.target = "_blank";
        document.body.appendChild(aLink);
        aLink.click();
        document.body.removeChild(aLink);
      });
    },

    chooseFile(event) {
      // 3.7.上传文件
      setTimeout(() => {
        let targetFile = event.target.files[0];

        if (this.fileTypes.accept.indexOf(targetFile.type) == -1) {
          this.$refs.referenceUpload.value = null;
          this.$message.error("请选择正确格式文件！");
          return false;
        }

        let formData = new FormData();
        formData.append("file", targetFile, targetFile.name);
        formData.append("skus", this.skus);

        this.openLoading();
        shoppingCarIntoMuchAddressRequest(formData).then((res) => {
          //this.orderInfo = res.data;
          this.onLoadOrderTable(res.data);
          this.$refs.referenceUpload.value = null;
          this.closeLoading();
        });
      }, 500);
    },

    parseSkus() {
      // 3.8.制作标准格式skus
      this.shoppingCar.forEach((item, index) => {
        console.log(item);
        let end = ")+";
        if (this.shoppingCar.length - 1 == index) {
          end = ")";
        }
        this.skus += item.sku + "(" + item.amount + end;
      });
    },

    submitInter() {
      // 3.9.确认导入
      // let data = this.orderInfo.map((item) => {
      //   delete item.goodsCount;
      //   delete item.kdAry;
      //   return item;
      // });
      let data = [];
      for (let j = 0; j < this.orderInfo.length; j++) {
        let r2 = this.orderInfo[j];
        let row = {};
        Object.keys(r2).some((key) => {
          if (key != "kdAry" && key != "goodsCount") {
            row[key] = r2[key];
          }
        });
        data.push(row);
      }

      this.openLoading();

      orderInsertsRequest(data).then((res) => {
        this.closeLoading();
        if (res) {
          if (res.code != 500) {
            let obj = {
              batchId: res.batchId,
              batchName: res.batchName,
              status: 1,
            };
            if (obj.batchId > 0) {
              this.$router.push(
                "/orderPay?obj2=" + encodeURIComponent(JSON.stringify(obj))
              );
            } else {
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        }
      });
    },

    addAddressBefore() {
      // 3.10.确认添加收货地址之前
      if (this.verifacation()) {
        this.cutAddress();
      }
    },
    getStocks() {
      ckListRequest().then((res) => {
        if (res) {
          this.ckList = res.data;
        }
      });
    },
    getKDInfo() {
      // 3.3.获取快递信息
      kdListRequest().then((res) => {
        if (res) {
          this.kdList = res.data;
          let ary = [];
          for (let j = 0; j < res.data.length; j++) {
            let r = res.data[j];
            if (r.isWeb == "0" && r.status == "0") {
              if (
                (r.isWebPlat || "0") == "0" ||
                (r.isWebSupplier || "0") == "0"
              ) {
                ary.push(r);
              }
            }
          }
          this.kdList2 = ary;
        }
      });
    },
    cutAddress() {
      // 3.11.手填地址请求处理格式
      this.openLoading();
      let data = {
        consignee: this.consignee,
        consigneePhone: this.consigneePhone,
        consigneeAddr: this.consigneeAddr,
        goodsSku: this.skus,
        remark: this.remark,
      };

      addressCutRequest(data).then((res) => {
        this.closeLoading();
        if (Array.isArray(res.data)) {
          this.ownParseOrderInfo(res.data);
        } else {
          this.ownParseOrderInfo(res.data);
        }
      });
    },

    onLoadOrderTable(obj) {
      if (!this.isStock) {
        this.orderInfo = obj.map((item) => {
          delete item.status;
          delete item.params;
          return item;
        });
      } else {
        let ary = [];
        for (let j = 0; j < obj.length; j++) {
          let row = obj[j];
          if (row.listGoodTemp) {
            for (var k = 0; k < row.listGoodTemp.length; k++) {
              let item = row.listGoodTemp[k];
              let ss = {};
              ss.consignee = row.consignee;
              ss.consigneePhone = row.consigneePhone;
              ss.province = row.province || "";
              ss.city = row.city || "";
              ss.area = row.area || "";
              ss.consigneeAddr = row.consigneeAddr || "";
              ss.goodsName = item.goodsName + "(" + item.goodsCount + ")";
              ss.goodsSku = item.goodsCode + "(" + item.goodsCount + ")";
              ss.goodsCode = item.goodsCode;
              ss.goodsStock = item.goodsStock || 0;
              ss.remark = row.remark;
              if ((row.errCode || "").indexOf("快递名称错误，") == -1) {
                ss.deliveryId = row.deliveryId || 1;
                ss.deliveryName = row.deliveryName || "京东快递";
              } else {
                ss.deliveryId = row.deliveryId;
                ss.deliveryName = row.deliveryName;
              }
              ss.stockId = row.stockId;
              ss.isDelivery = 1;
              let kdAry = [];
              for (let p = 0; p < this.kdList.length; p++) {
                let dd = this.kdList[p];
                if (dd.deliveryId == ss.deliveryId) {
                  if (dd.status == "0" && dd.isWeb == "0") {
                    ss.isDelivery = 0;
                    break;
                  }
                }
              }
              for (let p = 0; p < this.ckList.length; p++) {
                let dd = this.ckList[p];
                if (dd.stockId == ss.stockId) {
                  ss.stockName = dd.stockName;
                  break;
                }
              }

              for (let p = 0; p < this.kdList.length; p++) {
                let dd = this.kdList[p];
                if (row.isSupplier == "0") {
                  if (row.isEditDelivery == "0") {
                    if ((dd.isWebPlat || "0") == "0") {
                      kdAry.push(dd);
                    }
                  } else {
                    if (dd.deliveryId == ss.deliveryId) {
                      kdAry.push(dd);
                    }
                  }
                }
                if (row.isSupplier == "1") {
                  if ((dd.isWebSupplier || "0") == "0") {
                    kdAry.push(dd);
                  }
                }
              }
              ss.kdAry = kdAry;
              ary.push(ss);
            }
          }
        }
        this.orderInfo = ary;
      }
    },
    ownParseOrderInfo(obj) {
      // 3.12.获取处理的地址信息开始根据填写的地址生成订单信息

      this.onLoadOrderTable(obj);
      this.adderssSwitch = false;
      this.adderssAddbox = false;
      this.consignee = "";
      this.consigneeAddr = "";
      this.consigneePhone = "";
    },

    openLoading() {
      // 3.13.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 3.14.关闭遮罩层
      this.loadingInstance.close();
    },
    closeAddressShow() {
      this.editShow = false;
    },
    saveAddress() {
      if (this.orderInfo.length > this.editIndex) {
        this.orderInfo[this.editIndex].province = this.dialogForm.province;
        this.orderInfo[this.editIndex].city = this.dialogForm.city;
        this.orderInfo[this.editIndex].area = this.dialogForm.area;
        this.orderInfo[this.editIndex].consigneeAddr =
          this.dialogForm.consigneeAddr;
      }
      this.editShow = false;
      console.log(this.dialogForm);
    },
    editAddress(index) {
      this.editShow = true;
      this.editIndex = index;
      if (this.orderInfo.length > this.editIndex) {
        this.dialogForm.consigneeAddr = this.orderInfo[index].consigneeAddr;
        this.dialogForm.province = this.orderInfo[index].province;
        this.dialogForm.city = this.orderInfo[index].city;
        this.dialogForm.area = this.orderInfo[index].area;
      }
      this.initAddress(this.dialogForm);
    },
    initAddress(vv) {
      for (let j = 0; j < this.dataProv.length; j++) {
        if (this.dataProv[j].name == vv.province) {
          this.dataCity = this.dataProv[j].cityList;
          break;
        }
      }
      for (let k = 0; k < this.dataCity.length; k++) {
        if (this.dataCity[k].name == vv.city) {
          this.dataArea = this.dataCity[k].areaList;
          break;
        }
      }
    },
    getProv: function (vv) {
      let index = 0;
      console.log(index);
      for (let j = 0; j < this.dataProv.length; j++) {
        if (this.dataProv[j].name == vv) {
          index = j;
          break;
        }
      }
      this.dataCity = this.dataProv[index].cityList;
      if (this.dataArea.length > 0) {
        this.dialogForm.city = this.dataCity[0].name;
      } else {
        this.dialogForm.city = "";
      }
    },
    getCity: function (vv) {
      let index = 0;
      for (let j = 0; j < this.dataCity.length; j++) {
        if (this.dataCity[j].name == vv) {
          index = j;
          break;
        }
      }
      console.log(index);
      this.dataArea = this.dataCity[index].areaList;
      if (this.dataArea.length > 0) {
        this.dialogForm.area = this.dataArea[0];
      } else {
        this.dialogForm.area = "";
      }
    },
    getArea: function (vv) {
      let index = 0;
      for (let j = 0; j < this.dataArea.length; j++) {
        if (this.dataArea[j] == vv) {
          index = j;
          break;
        }
      }
      console.log(index);
      //this.form.counties = this.dataArea[index];
    },

    getShowStock(v) {
      if (v >= 9999) {
        return "有货";
      }
      return v;
    },
    editDelivery(index) {
      this.deliveryShow = true;
      console.log(this.orderInfo[index].kdAry);
      this.kdList2 = this.orderInfo[index].kdAry || [];
      this.kdForm.deliveryId = this.orderInfo[index].deliveryId;
      this.editIndex = index;
    },

    closeDelivery() {
      // 3.10.关闭开票遮罩层
      this.deliveryShow = false;
    },
    saveDelivery() {
      if (this.orderInfo.length > this.editIndex) {
        this.orderInfo[this.editIndex].deliveryId = this.kdForm.deliveryId;

        for (let j = 0; j < this.kdList.length; j++) {
          if (this.kdList[j].deliveryId == this.kdForm.deliveryId) {
            this.kdForm.deliveryName = this.kdList[j].deliveryName;
            if (this.kdList[j].status == "0" && this.kdList[j].isWeb == "0") {
              this.orderInfo[this.editIndex].isDelivery = 0;
            }
            break;
          }
        }
        this.orderInfo[this.editIndex].deliveryName = this.kdForm.deliveryName;
      }
      this.deliveryShow = false;
      console.log(this.kdForm);
    },

    editStock(index) {
      this.stockShow = true;
      this.ckForm.stockId = parseInt(this.orderInfo[index].stockId);
      this.editIndex = index;
    },

    closeStock() {
      this.stockShow = false;
    },

    saveStock() {
      let goodsCode = "0";
      let stockId = 0;
      let goodCount = 0;
      if (this.orderInfo.length > this.editIndex) {
        stockId = this.ckForm.stockId;
        this.orderInfo[this.editIndex].stockId = this.ckForm.stockId;
        goodsCode = this.orderInfo[this.editIndex].goodsCode;
        for (let j = 0; j < this.ckList.length; j++) {
          if (this.ckList[j].stockId == this.ckForm.stockId) {
            this.ckForm.stockName = this.ckList[j].stockName;
            break;
          }
        }
        this.orderInfo[this.editIndex].stockName = this.ckForm.stockName;
      }

      //处理库存状态
      if (stockId > 0) {
        getGoodStockRequest({ sendId: stockId, goodsCode: goodsCode }).then(
          (res) => {
            if (res.data.goodsStock >= goodCount) {
              this.orderInfo[this.editIndex].goodsStock = res.data.goodsStock;
            }
          }
        );
      }

      this.stockShow = false;
      console.log(this.ckForm);
    },

    getCityJson() {
      cityRequest(1).then((res) => {
        if (res) {
          this.dataProv = res;
        }
      });
    },
  },

  props: {
    // 4.props
    shoppingCar: [Array, Object], // 4.1.购物车商品信息
  },

  mounted() {
    // 5.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getKDInfo();
      this.getStocks();
      this.parseSkus();
      this.getList();
    }
    this.getCityJson();
  },
};
</script>

<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.all-container {
  width: px2vw(1150px);
  max-width: 1700px;
  margin: 0 auto;
  font-size: 13px;

  > .main {
    flex: 1;
    overflow: hidden;
    > .title {
      font-size: 15px;
      color: #999;

      > .right {
        background-color: $mainColor1;
        color: #fff;
        padding: 4px 14px;
        border-radius: 4px;
      }
    }

    > .main {
      padding-top: 20px;
      padding-bottom: px2vw(20px);
      position: relative;

      > .inter {
        position: absolute;
        top: 20px;
        right: 10px;

        > .item {
          background-color: $mainColor1;
          color: #fff;
          border-radius: px2vw(4px);
          font-size: 14px;
          padding: 6px 20px;
          margin-right: 20px;
          position: relative;

          > .getInterOrder {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }

      > .info {
        font-size: 14px;
        overflow: hidden;
        transition: all 0.5s;
        height: 0;

        > .item {
          margin-bottom: 20px;

          > .top {
            margin-bottom: 10px;
            font-weight: bold;

            > span {
              color: $mainColor3;
              padding-right: px2vw(4px);
            }
          }

          > .bottom {
            width: px2vw(500px);
            height: px2vw(32px);
            max-width: 500px;
            max-height: 40px;
            border: 1px solid #ddd;
            border-radius: 4px;
            overflow: hidden;
            box-sizing: border-box;
            padding-left: px2vw(10px);
            margin-left: 10px;
          }

          > .bottom2 {
            height: px2vw(140px);
            max-height: 140px;
            padding-left: 0;
          }
        }

        > .buttons {
          background-color: $mainColor1;
          color: #fff;
          border-radius: px2vw(4px);
          font-size: 14px;
          width: px2vw(100px);
          height: px2vw(32px);
          max-width: 100px;
          max-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
        }
      }

      > .info-on {
        height: 520px;
      }

      > .buttons {
        padding-top: 40px;

        > .item {
          background-color: $mainColor1;
          color: #fff;
          border-radius: 6px;
          font-size: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 px2vw(14px) px2vw(10px) 0;
          padding: 10px 130px;
        }
      }

      > .goods {
        margin: 20px 0;

        > .area {
          border-bottom: 1px solid #ddd;
          padding: 20px 0;
          margin-bottom: 20px;

          > .top {
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          > .bottom {
            > .item {
              margin-bottom: 10px;
              padding: 20px;
              border-radius: 6px;

              > div {
                flex-shrink: 0;
              }

              > .photo {
                width: px2vw(70px);
                height: px2vw(70px);
                max-width: 70px;
                max-height: 70px;
                margin-right: px2vw(10px);
              }

              > .name {
                flex: 1;
              }

              > .onePrice {
                width: px2vw(110px);
                margin-left: px2vw(20px);
              }

              > .allPrice {
                width: px2vw(130px);
                margin-left: px2vw(20px);
              }

              > .number {
                margin: 0 px2vw(20px);

                > div {
                  width: px2vw(20px);
                  height: px2vw(20px);
                  border: 1px solid #ddd;
                  margin-left: px2vw(10px);
                }
              }

              > .btns {
                > .btn {
                  background-color: $mainColor1;
                  color: #fff;
                  border-radius: px2vw(4px);
                  padding: px2vw(5px) px2vw(20px);
                }
              }
            }
          }

          > .bottom2 {
            text-align: center;
            margin: 20px 0;
            > span {
              color: $mainColor3;
              display: inline-block;
              margin: 0 px2vw(10px);
            }
          }
        }
      }

      > .order {
        > .title {
          background-color: #f5f5f5;
          box-sizing: border-box;
          font-size: 15px;
          font-weight: bold;

          margin-bottom: 14px;
          padding: px2vw(10px);

          > div {
            box-sizing: border-box;
            padding: 0 px2vw(4px);
            text-align: center;

            &:nth-child(1) {
              width: 6%;
              text-align: center;
            }

            &:nth-child(2) {
              flex: 1;
            }

            &:nth-child(3) {
              width: 15%;
            }

            &:nth-child(4) {
              width: 6%;
            }

            &:nth-child(5) {
              width: 10%;
            }

            &:nth-child(6) {
              width: 18%;
            }

            &:nth-child(7) {
              width: 11%;
            }
          }
        }

        > .goods {
          margin-bottom: 20px;
          box-sizing: border-box;
          padding: px2vw(10px);
          border-radius: px2vw(5px);
          overflow: hidden;
          font-size: px2vw(12px);
          position: relative;

          > .top {
            width: 100%;
            font-size: 14px;

            > div {
              box-sizing: border-box;
              padding: 0 px2vw(4px);
              text-align: center;

              &:nth-child(1) {
                width: 6%;
                font-weight: bold;
              }

              &:nth-child(2) {
                flex: 1;
              }

              &:nth-child(3) {
                width: 15%;
                color: #999;
              }

              &:nth-child(4) {
                width: 6%;
              }

              &:nth-child(5) {
                width: 10%;
                // color: $mainColor3;
                padding: 0 px2vw(8px);
              }

              &:nth-child(6) {
                width: 18%;
                // color: $mainColor3;
                padding: 0 px2vw(8px);
              }

              &:nth-child(7) {
                width: 11%;
                // color: $mainColor3;
                padding: 0 px2vw(8px);
              }
            }
          }
        }

        > .none {
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
}
/* 1.all-container-style-start */
</style>
